export const SERVICE_STATUS = {
  SERVICE_CREATED: 0,
  SERVICE_UP: 1,
  SERVICE_DOWN: 2,
};
export const PROJECT_STATUS = {
  PROJECT_CREATED: 0,
  PROJECT_ARCHIVED: -1,
};

export const ROLE = {
  NONE: 0,
  ADMIN: 1,
  USER: 2,
};

export const LOGS_LEVEL = {
  INFO: 4,
  WARN: 3,
  ERROR: 2,
  FATAL: 1,
};
export const SERVICE_COLOR = {
  [SERVICE_STATUS.SERVICE_UP]: '#75a52b',
  [SERVICE_STATUS.SERVICE_DOWN]: 'red',
};

export const LOG_COLOR = {
  [LOGS_LEVEL.INFO]: 'green',
  [LOGS_LEVEL.WARN]: 'orange',
  [LOGS_LEVEL.ERROR]: 'red',
  [LOGS_LEVEL.FATAL]: 'red',
};
export const SOCKET_URL = 'wss://monitor.sociowatch.in/socket?';
export const SERVER_URL = 'https://monitor.sociowatch.in/rpc';
export const UPLOAD_URL = 'https://monitor.sociowatch.in/upload';
export const SERVICE_METHOD = {
  LIST: 'service.list',
  GET: 'service.get',
  CREATE: 'service.create',
  UPDATE: 'service.update',
  DELETE: 'service.delete',
  CPU_HEALTH: 'service.cpuhealth',
  LOGS: 'service.logs',
  ALERTS: 'service.alerts',
};
export const TAB_TYPES = {
  Services: 'service',
  Projects: 'project',
  Notifications: 'notifications',
  Users: 'userlistsettings',
  Hook: 'hook',
};
export const PROJECT_METHOD = {
  LIST: 'project.list',
  GET: 'project.get',
  CREATE: 'project.create',
  UPDATE: 'project.update',
  DELETE: 'project.delete',
  LOGS: 'project.logs',
};

export const HOOK_METHOD = {
  LIST: 'hook.list',
  GET: 'hook.get',
  CREATE: 'hook.create',
  UPDATE: 'hook.update',
  DELETE: 'hook.delete',
  SEND: 'hook.send',
};

export const USER_METHOD = {
  LIST: 'user.list',
  GET: 'user.get',
  CREATE: 'user.create',
  UPDATE: 'user.update',
  DELETE: 'user.delete',
  CHANGE_PASSWORD: 'user.changepassword',
  LOGIN: 'auth.login',
};
export const MESSAGE = {
  COLON: ':',
  WELCOME: 'socket.welcome',
  INSERT_LOGS: 'service.insertlogs',
  INSERT_ALERTS: 'service.insertalerts',
  INSERT_CPU_HEALTH: 'service.insertcpuhealth',
  SOCKET_DISCONNECT: 'socket.forcedisconnect',
  BRACES: '{',
};
